import React from 'react'
import { Table } from 'widgets/crud'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as Columns from 'support/columns'
import { ChecklistName } from 'support/displays/ChecklistName'
import OnClickTableRow from 'widgets/crud/OnClickTableRow'
import { useEnvValue } from '@morningtrain/react-helpers'
import EmployeeOnboardingInfo from './EmployeeOnboardingInfo'
import OnboardingChecklistActivity from 'support/displays/OnboardingChecklistActivity'
import OnboardingChecklistProgress from 'support/displays/OnboardingChecklistProgress'
import * as UI from 'ui'
import { ValueToCollection } from '@morningtrain/react-resources'

export default function EmployeeOnboardingListView () {
  const [, setFocusedOnboarding] = useEnvValue('onboarding.focused_list', null)

  const editOnboarding = (model, id) => {
    setFocusedOnboarding(id)
  }

  return (
    <UI.CardWithHeader header={<EmployeeOnboardingInfo/>}>
      <hr/>
      <Translator namespace='checklists.columns'>
        <ValueToCollection name='collection'>
          <Table row={<OnClickTableRow callback={editOnboarding}/>}>
            <Columns.Text
              name='list' label={<Translation name='list'/>}
              display={<ChecklistName/>}
            />
            <Columns.Text
              name='activity' label={<Translation name='activity'/>}
              display={<OnboardingChecklistActivity/>}
            />
            <Columns.Text
              name='progress' label={<Translation name='progress'/>}
              display={<OnboardingChecklistProgress progressName='completed_percentage'/>}
            />
          </Table>
        </ValueToCollection>
      </Translator>
    </UI.CardWithHeader>
  )
}
